export default __webpack_public_path__ + "5b824a726edcf6642539e81a3534f3ad.woff";